<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the
project root for license information.
-->

<div class="enchilada">
  <div class="team-list-container elevate">
    <div class="team-list-header">
      <div class="center-self">
        <mat-icon class="mdi-24px header-icon" fontIcon="mdi-account-multiple-outline"></mat-icon>
      </div>
      <div class="center-self">
        MSEL Teams
      </div>
      <div class="search-div">
        <mat-form-field style="width: 75%; margin-left:10%;">
          <input matInput [(ngModel)]="filterString" (keyup)="applyFilter($any($event.target).value)"
            placeholder="Search" />
        </mat-form-field>
        <button [disabled]="!filterString" mat-icon-button (click)="clearFilter()"
          style="outline: none; margin-top: -10px;" title="Clear Search">
          <mat-icon class="mdi-24px" fontIcon="mdi-close-circle-outline"></mat-icon>
        </button>
      </div>
    </div>
    <hr />

    @if (teamDataSource.filteredData.length > 0) {
    <mat-table class="mat-table-msel-teams" #table [dataSource]="teamDataSource" matSort>
      <ng-container matColumnDef="name">
        <mat-cell *matCellDef="let element">
          @if (element.shortName) {
          <div>{{ element.shortName }}</div>
          }
          @if (!element.shortName && element.name) {
          <div>{{ element.name }}</div>
          }
          @if (!element.shortName && !element.name) {
          <div>{{ element.id }}</div>
          }
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="id">
        <mat-cell *matCellDef="let element">
          @if (canEditMsel()) {
          <div>
            <button mat-icon-button (click)="addTeamToPlayerApplication(element)" title="Add {{ element.name }}">
              <mat-icon class="mdi-18px" fontIcon="mdi-plus-circle-outline" title="Add {{ element.name }}"></mat-icon>
            </button>
          </div>
          }
        </mat-cell>
      </ng-container>
      <mat-row *matRowDef="let row; columns: mselTeamColumns"></mat-row>
    </mat-table>
    }
    @if (teamDataSource.filteredData.length === 0) {
    <div>No teams found</div>
    }
  </div>

  <div class="player-application-list-container elevate">
    <div class="player-application-list-header">
      <div class="head-name center-self">
        <mat-icon class="mdi-24px header-icon" fontIcon="mdi-account-group-outline"></mat-icon>
        Player Application Teams
      </div>
      <div class="head-right">&nbsp;</div>
    </div>
    <hr />

    @if (false) {
    <mat-card appearance="outlined" style="display: flex; justify-content: center; align-items: center;">
      <mat-progress-spinner color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </mat-card>
    }

    <mat-table class="mat-table-player-application-teams" #table [dataSource]="playerApplicationTeamDataSource" matSort>
      <ng-container matColumnDef="name">
        <mat-cell *matCellDef="let element">
          <div>{{ getTeamShortName(element.teamId) }}</div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="id">
        <mat-cell *matCellDef="let element">
          @if (canEditMsel()) {
          <div>
            <button mat-icon-button (click)="removeTeamFromPlayerApplication(element.id)"
              title="Remove {{ element.name }}">
              <mat-icon class="mdi-18px" fontIcon="mdi-minus-circle-outline"
                title="Remove {{ element.name }}"></mat-icon>
            </button>
          </div>
          }
        </mat-cell>
      </ng-container>

      <mat-row *matRowDef="let row; columns: playerApplicationTeamColumns"></mat-row>
    </mat-table>

  </div>
</div>
